import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    body_single_file: string;
    body_multiple_files: string;
    disclaimer: string;
    saveForFuture: string;
    buttonLabel: string;
    cancelLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title of the modal */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscriptionConsentModal.title?c=105nvladxjlms", defaultMessage: "Label Speakers" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Body text for the modal - used with single file */
            body_single_file: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscriptionConsentModal.body_single_file?c=1fuxylbjwy4k0", defaultMessage: "Frame.io Transcription will process the voices in this file to separate the transcript by speaker (e.g. Speaker 1, Speaker 2). By using this feature, you confirm that the individuals featured in this content provided approval for you to do so." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Body text for the modal - used with multiple files */
            body_multiple_files: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscriptionConsentModal.body_multiple_files?c=27ibgjj5zht9y", defaultMessage: "Frame.io Transcription will process the voices in these files to separate the transcript by speaker (e.g. Speaker 1, Speaker 2). By using this feature, you confirm that the individuals featured in this content provided approval for you to do so." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Disclaimer text */
            disclaimer: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscriptionConsentModal.disclaimer?c=1dv43wqx9lsr7", defaultMessage: "This feature may not be available in certain locations." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Consent checkbox text */
            saveForFuture: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscriptionConsentModal.saveForFuture?c=2wh75leynzokm", defaultMessage: "I consent to speaker labeling for all future transcriptions" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Agree button label */
            buttonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscriptionConsentModal.buttonLabel?c=oqre76vwq1am", defaultMessage: "I Agree" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Cancel button label */
            cancelLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscriptionConsentModal.cancelLabel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
